interface WizardContentProps {
    children: React.ReactNode;
}
const WizardContent = ({ children }: WizardContentProps) => (
    <div className="p-6 pt-2">{children}</div>
);

export default WizardContent;